import httpClient from '../httpClient';


const getEntertainment =  (page,pagesSize) => httpClient.get(`/Entertainment?page=${1}&pageSize=${1000}`).then(
  (data) => data
)
  .catch((e)=>{
   //
  })
const setEntertainment =  (params) => httpClient.post('/Entertainment', params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

const putEntertainment = (params,id) => httpClient.put(`/Entertainment/${id}`, params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })


const  deleteEntertainment= (id) => httpClient.delete(`/Entertainment/${id}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

export {
  getEntertainment,
  setEntertainment,
  putEntertainment,
  deleteEntertainment,
  // getUser,
  // createUser
}
